import { Component, Input } from '@angular/core';
import { BusinessClient } from '@models/clients';
import { ClientsDispatch } from '@state/clients';

@Component({
	selector: 'app-edit-business-client',
	templateUrl: './edit-business-client.component.html',
	standalone: false,
})
export class EditBusinessClientComponent {
	@Input() company: BusinessClient;

	constructor(private clientsDispatch: ClientsDispatch) {}

	setCompanyName = (companyName: string) =>
		this.clientsDispatch.OverwriteBusinessClientFields(
			this.company.id,
			'name',
			companyName,
		);
}
